import { FC, FormEvent, ReactNode, useState } from 'react';
import { withForm } from 'react-bootstrap-formutil';
import Button from 'components/base/Button';
import Modal, { ModalHandler } from 'components/base/Modal';
import classlist from 'utils/classlist';
import { isEmptyValue } from 'utils/helper';
import { MobileContentProps, OptionType, OptionValueType } from '../type';
import styles from './style.scss';

export interface PickerModalProps extends ModalHandler {
    className?: string;
    value: OptionValueType;
    options: OptionType[];
    // 完全自定义弹窗里的内容，包括头部和选项内容
    contentRender?: (props: MobileContentProps) => ReactNode;
    // 是否隐藏默认顶栏。可以在modalContent中完全自定义header
    hideHeader?: boolean;
}

const PickerModal: FC<PickerModalProps> = ({
    className,
    contentRender,
    close,
    dismiss,
    options,
    value,
    hideHeader
}) => {
    const [curValue, setCurValue] = useState<PickerModalProps['value']>(
        (value || []).filter(val => !isEmptyValue(val))
    );

    // 支持单选弹窗选择完直接关闭
    const handleChange = (value: OptionValueType, isClose?: boolean) => {
        if (isClose) {
            close(value.filter(item => !isEmptyValue(item)));
        } else {
            setCurValue(value);
        }
    };
    const handleSubmit = (ev: FormEvent) => {
        ev.preventDefault();

        close(curValue.filter(val => !isEmptyValue(val)));
    };

    return (
        <form className={classlist(styles.modal, className)} noValidate onSubmit={handleSubmit}>
            {/* 默认的顶部操作区域 */}
            {!hideHeader && (
                <div className={styles.header}>
                    <Button className={styles.cancel} onClick={() => dismiss()} type="link">
                        {__('Cancel')}
                    </Button>
                    <span className={styles.title}>{__('Picker:Select')}</span>
                    <Button className={styles.confirm} htmlType="submit" type="link">
                        {__('确定')}
                    </Button>
                </div>
            )}
            {contentRender && contentRender({ value: curValue, options, onChange: handleChange, onDismiss: dismiss })}
        </form>
    );
};

const PickerModalWithForm = withForm(PickerModal);

export default PickerModalWithForm;

export const openPickerModal = (props: Omit<PickerModalProps, keyof ModalHandler>) => {
    return Modal.openSlideModal({
        component: modalProps => <PickerModalWithForm {...props} {...modalProps} />,
        responsive: true,
        backdrop: 'static'
    }).result.catch(() => {});
};
